/*
Global constants for report-related settings (e.g. Embargoing)
*/

export const SQS_EMBARGO_YEAR = null // use null if none are embargoed
export const SQS_PROJ_GRAD_RATE_YEAR = null // use null if 4yr HS grad rate is no longer projected
export const SQS_NO_PK_YEAR = 2025 // use null if PK are all publicly available

export const SQS_COVID_YEARS = Object.freeze([
  2022,
  2021,
  2020
])

// Secret Keys for Embargoed PK SQS Report
// - Not super-secret, since publicly available
// - Keys should be a string that is URL-friendly, length > 0
//   - For example alphanumeric/underscore (\w)
//   - Recommended 32 chars to make it too long to type
//   - URLS are sometimes case-insensitive: router is set to sensitive, and app
//     also does exact match, so recommended to do only lowercase/number keys
//   - Snippet to generate random [a-z0-9] - can do up to 9 chars, but just do
//     this four times to get 32 chars:
//       Math.random().toString(36).substr(2, 8)
// - One key per year, don't duplicate previous keys
// - If no key for a given year, that means there is no embargoed PK yet
// - Only the one for SQS_NO_PK_YEAR should ever be in use
export const SQS_PK_SECRET_KEYS = {
  2023: 'nrfaug4rqihdrlfz3o03ka5wia0xvwlx',
  2022: 'vj6fkl4rnuxwqhgyipj19xni37w2uhgt',
  2021: 'cw17k70d56li35midwgs62rg05f2dj60',
  2020: '8403jqk060maq8b9s41vwtoenb6a3oas',
  2019: '1lp5q14d4cy34879v860kzmx3dz5ziqf',
  2018: '1cvkdidnoron76r49n2uc6ftfxxikdxr'
}



// WEBPACK FOOTER //
// ./src/report-settings.js